import { skipToken } from '@tanstack/react-query';
import { Dispatch, SetStateAction, useEffect } from 'react';
import { Batch, Operation } from '../../types/sharedTypeImpl.ts';
import { trpc } from '../../utils/trpc/trpc.ts';
import { OperationDraft } from './operationDraft.ts';


export function useGetInitialOrderNumber(
    batch: Batch | null,
    operationUnderEdit: Operation | null | undefined,
    setOperation: Dispatch<SetStateAction<OperationDraft>>,
) {

    const { data } = trpc.batchDetails.get.useQuery(
        batch && operationUnderEdit == null ? {
            equipment: batch.equipment,
            product: batch.product,
            batchStart: batch.start,
        } : skipToken,
        {
            refetchOnWindowFocus: false,
            refetchOnReconnect: false,
            refetchOnMount: false,
        },
    );

    useEffect(() => {
        if (data && data.orderNumber) {
            setOperation((operation) => ({ ...operation, orderNumber: data.orderNumber }));
        }
    }, [data, setOperation]);
}
